import React from 'react'
import { Outlet } from 'react-router-dom'

export default function OfferSection() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}
